import React from "react";

import styles from "../../../../styles/secrets-drawers.module.scss";
import { Drawer } from "../../../components/Drawer";
import { Button } from "../../../components/Button";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { IntegrationsAPI } from "../../../../providers/IntegrationsAPI";
import { OpenDeliveryApi } from "../../../../providers/OpendeliveryAPI";
import { Message } from "../../../components/Message";

export default class OpenDeliveryRefreshDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      active: true,
      clientId: null,
      clientSecret: null,
      apiUrl: null,
      merchantId: null,
      apiKey: null,
      merchantUrl: null,
      deliveredBy: null,
    };
  }

  async componentDidMount() {
    const openDeliveryResponse =
      await IntegrationsAPI.getOpenDeliveryCredentials(
        EnvironmentStorage.getSelectedEnvironment()
      );

    const openDelivery = openDeliveryResponse.getData({});
    this.setState({
      clientId: openDelivery?.client_id,
      clientSecret: openDelivery?.client_secret,
      apiUrl: openDelivery?.url,
      merchantId: openDelivery?.merchantId,
      merchantUrl: openDelivery?.merchantUrl,
      apiKey: openDelivery?.apiKey,
      deliveredBy: openDelivery?.deliveredBy,
    });
  }

  async asyncOpenDelivery() {
    this.setState({ loading: true });

    const updateResponse = await OpenDeliveryApi.postOpenDeliveryRefresh({
      client_id: this.state.clientId,
      client_secret: this.state.clientSecret,
    });

    if (updateResponse.getErrors([]).length > 0) {
      alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
      this.setState({ loading: false });
      return false;
    } else {
      alert({ text: "Dados atualizados com sucesso", buttonText: "Ok" });
    }

    this.setState({ loading: false });

    return true;
  }

  render() {
    const { loading } = this.state;
    const { visible, onClose } = this.props;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Open Delivery"
      >
        <div className={styles.secretDrawerContainer}>
          <Message>
            <p>
              Ao realizar a atualização, todos os dados do Open Delivery serão
              sincronizados. No entanto, links de imagens provenientes do pdv
              que estejam expirados poderão comprometer a configuração das
              imagens do cardápio.
            </p>
          </Message>

          <div className={styles.footer}>
            <Button
              design="primary"
              className="w-100"
              onClick={() => this.asyncOpenDelivery()}
              loading={loading}
              disabled={loading || !this.state.apiUrl}
            >
              Atualizar
            </Button>
          </div>
        </div>
      </Drawer>
    );
  }
}
